import React, { useState, useEffect, useCallback } from 'react';
import { useLang } from '../context/LangContext';
import api from '../utils/api';
import './PageCommon.css';

export default function Campaigns() {
  const { lang } = useLang();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCampaigns = useCallback(() => {
    return api.get('/broadcast/get_campaigns')
      .then(r => { if (r.data?.success) setCampaigns(r.data.data || []); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchCampaigns().finally(() => setLoading(false));
  }, [fetchCampaigns]);

  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1>{lang === 'en' ? 'Campaigns' : 'Campañas'}</h1>
          <p>{lang === 'en' ? 'Send bulk messages to your contacts' : 'Envía mensajes masivos a tus contactos'}</p>
        </div>
      </div>

      {loading ? (
        <div className="page__loading"><div className="spinner" /></div>
      ) : campaigns.length === 0 ? (
        <div className="page__empty">
          <span className="page__empty-icon">📢</span>
          <h3>{lang === 'en' ? 'No campaigns yet' : 'Sin campañas aún'}</h3>
          <p>{lang === 'en' ? 'Campaigns will appear here once you create them. Connect a WhatsApp profile first.' : 'Las campañas aparecerán aquí cuando las crees. Conecta un perfil de WhatsApp primero.'}</p>
        </div>
      ) : (
        <div className="page__grid">
          {campaigns.map(c => (
            <div className="page__card" key={c.id}>
              <div className="page__card-header">
                <h3>{c.title || c.name || `Campaign #${c.id}`}</h3>
                <span className={`page__status page__status--${(c.status || 'draft').toLowerCase().replace(/\s+/g, '-')}`}>
                  {c.status || 'Draft'}
                </span>
              </div>
              <div className="page__card-meta">
                {c.createdAt && <span>{new Date(c.createdAt).toLocaleDateString()}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
